<template>
  <div>
    <b-modal
      id="careerModal"
      size="sm"
      hide-header
      hide-footer
      content-class="custom-modal-content"
      ref="baseModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div
        class="d-flex flex-column align-items-center justify-content-center h-100"
      >
        <p class="modal-title text-center mb-4" v-html="modalText"></p>
        <div class="button-container">
          <button
            :style="{
              backgroundColor: '#fffff',
              borderRadius: '2px',
              color: '#3c3c3c',
              borderColor: '#3c3c3c',
              padding: '10px',
            }"
            class="btn custom-btn"
            @click="$emit('cancel')"
          >
            キャンセル
          </button>
          <button
            :style="{
              backgroundColor: '#EB5757',
              borderRadius: '2px',
              color: '#fff',
              borderColor: '#EB5757',
              padding: '10px',
            }"
            class="btn custom-btn"
            @click="$emit('submit')"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    modalText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    option: {
      type: String,
    },
  },
  methods: {
    show() {
      this.$refs.baseModal.show();
    },
    hide() {
      this.$refs.baseModal.hide();
    },
  },
  mounted() {
    this.$bvModal.show('careerModal');
  },
};
</script>

<style scoped>
.button-container {
  width: 100%;
  display: flex;
  /* gap: 40px; */
  justify-content: space-around;
  flex-direction: row;
  align-items: baseline;
  margin-top: 20px;
}
.custom-btn {
  margin-top: 45px;
  width: 165px;
  height: 50px;
  font-weight: bold;
  font-size: 14px;
}
>>> .custom-modal-content {
  height: 429px !important;
  width: 506px !important;
  margin: auto;
}

>>> .modal-content {
  height: 100%;
}

>>> .modal-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-title {
  font-size: 24px;
  line-height: 60px;
  font-weight: bold;
}
</style>
